export default __webpack_public_path__ + "static/media/IMG_1182.13268a05.jpg";